export default "__VITE_ASSET__Chixl8QC__"